import React from "react";
import { Button } from "../ui/button";
import { Alert, AlertDescription } from "../ui/alert";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Spinner } from "../ui/spinner";
import { AlertTriangle } from "lucide-react";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  loading,
  title,
  itemName,
  itemType,
  warningMessage,
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-red-600" />
            {title || `Delete ${itemType}`}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <Alert variant="destructive">
            <AlertTriangle className="h-4 w-4" />
            <AlertDescription>
              This action cannot be undone. This will permanently delete the{" "}
              {itemType}.
            </AlertDescription>
          </Alert>

          <div className="space-y-2">
            <p className="text-sm text-gray-700">
              Are you sure you want to delete the {itemType}:
            </p>
            <p className="font-semibold text-gray-900 bg-gray-50 p-2 rounded border">
              {itemName}
            </p>
            {warningMessage && (
              <p className="text-sm text-orange-600 mt-2">{warningMessage}</p>
            )}
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading && <Spinner size="sm" className="mr-2" />}
              Delete {itemType}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
